import React, {useEffect, useState} from 'react';

import {Cache} from 'aws-amplify';

import {ButtonGhostIcon} from 'pac-ux-components';

import {AiOutlineCloudDownload} from 'react-icons/ai';

import {I18n} from '@aws-amplify/core';

import {Box, Grid, SimpleGrid} from '@mantine/core';

import config from 'config';

const { about } = config;

const METADATA_LOCAL_STORAGE_KEY = 'pac-app-metadata';
const METADATA_LOCAL_STORAGE_VALUE = {
    version: 1,
};

export const VersionControl = () => {
    const [currentVersion, setCurrentVersion] = useState(false);

    useEffect(() => {
        const metadata = Cache.getItem(METADATA_LOCAL_STORAGE_KEY, {
            callback: () => {
                return METADATA_LOCAL_STORAGE_VALUE;
            },
        });

        setCurrentVersion(metadata.version);
    }, []);

    const handleUpgrade = () => {
        // clear
        Cache.clear();
        // store
        Cache.setItem(METADATA_LOCAL_STORAGE_KEY, {
            version: about.latestVersion,
        });
        window.location.href = about.host + '/about';
    };

    return (
        <SimpleGrid>
            <Grid>
                <Grid.Col span={6}>
                    <Box variant="h4" mt="xl">
                        {I18n.get('Latest Version')}:
                    </Box>
                </Grid.Col>
                <Grid.Col span={2}>
                    <Box variant="h4" mt="xl">
                        {about.latestVersion}
                    </Box>
                </Grid.Col>

                <Grid.Col span={4}></Grid.Col>
            </Grid>

            <Grid>
                <Grid.Col span={6}>
                    <Box variant="h4" mt="xl">
                        {I18n.get('Current Version')}:
                    </Box>
                </Grid.Col>
                <Grid.Col span={2}>
                    <Box variant="h4" mt="xl">
                        {currentVersion}
                    </Box>
                </Grid.Col>
                <Grid.Col span={4}>
                    {currentVersion < about.latestVersion ? (
                        <ButtonGhostIcon
                            type="button"
                            icon={<AiOutlineCloudDownload />}
                            onClick={handleUpgrade}
                            tabIndex={3}
                        >
                            {I18n.get('Upgrade')}
                        </ButtonGhostIcon>
                    ) : null}
                </Grid.Col>
            </Grid>
        </SimpleGrid>
    );
};
